import axios from 'axios';


export function submitStat(data) {
    return axios({
        url: "/stats/report",
        method: 'post',
        data
    });
}
